import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import b_ from 'b_';
import ConsoleModal from '../ConsoleModal/ConsoleModal';
import ConsoleCheckbox from '../ConsoleFragments/ConsoleCheckbox';
import AccessCodesEditStore from '../../stores/BrowserPolicies/AccessCodesEditStore';
import Button from '../Button';
import SnackStore from '../../stores/SnackStore';
import BrowserPoliciesStore from '../../stores/BrowserPolicies/BrowserPoliciesStore';
import './AccessCodeActionModal.css';

const block = b_.lock('AccessCodeActionModal');

const CB_LABEL_PREFIX = 'Confirm this access code should be';
const DELETE_CODE = '- Deleted access codes cannot be restored. Browsers activated with this code ' +
    'will be reverted back to the default policy.';
const DEACTIVATE_CODE = '- Deactivated codes cannot be restored. Deactivating a code will prevent new ' +
    'users from activating their browsers with this code. However all previously activated browsers ' +
    'will still have access to Proofpoint Isolation.';


class AccessCodeActionModal extends Component {
    static propTypes = {
        browserPolicies: BrowserPoliciesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
        title: PropTypes.string.isRequired,
        headerActionText: PropTypes.string.isRequired,
        checkboxLabel: PropTypes.string.isRequired,
        isOpen: PropTypes.bool.isRequired,
    };

    onSubmit = (event) => {
        event.preventDefault();
        const { browserPolicies } = this.props;
        const { accessCodesEditStore } = browserPolicies;
        const policyName = accessCodesEditStore.policy.name;
        accessCodesEditStore.onAccessCodeSubmit()
            .then((response) => {
                if (accessCodesEditStore.modalType === AccessCodesEditStore.MODAL_TYPE.DEACTIVATE) {
                    browserPolicies.updateAccessCode(response);
                    this.props.snack.showSuccess(`${policyName} access code ${response.code} has been deactivated.`);
                } else {
                    browserPolicies.removeAccessCode(response);
                    this.props.snack.showSuccess(`${policyName} access code ${response.code} has been deleted.`);
                }
            })
            .catch((e) => e && this.props.snack.showError(`Failed to add policy. ${e.message}`));
    };

    render() {
        const { browserPolicies } = this.props;
        const { accessCodesEditStore } = browserPolicies;

        let importantSection = '';

        if (accessCodesEditStore.modalType === AccessCodesEditStore.MODAL_TYPE.DELETE) {
            importantSection = DELETE_CODE;
        }

        if (accessCodesEditStore.modalType === AccessCodesEditStore.MODAL_TYPE.DEACTIVATE) {
            importantSection = DEACTIVATE_CODE;
        }

        return <Fragment>
            <ConsoleModal
                isOpen={this.props.isOpen}
                onClose={accessCodesEditStore.closeModal}
                title={this.props.title}
                style={{ content: { width: '100%' } }}
                contentClassName={block()}
                headerActions={<Button
                    red
                    raised
                    disabled={!accessCodesEditStore.confirmAction.isTrue}
                    onClick={this.onSubmit}
                >{this.props.headerActionText}</Button>}
            >
                <div className={block('StaticContentWrapper')}>
                    <div className={block('FieldTitle')}>Policy Name</div>
                    <div>{accessCodesEditStore.policyName}</div>
                    <div className={block('FieldTitle')}>Access Code</div>
                    <div>{accessCodesEditStore.accessCode}</div>
                    <div className={block('FieldTitle')}>Activations</div>
                    <div>{accessCodesEditStore.activations}</div>
                    <div className={block('FieldTitle')}>Code Valid Through (GMT)</div>
                    {accessCodesEditStore.neverExpire.isTrue ?
                        <div>{'Never Expire'}</div> :
                        <div className={block('DateString')}>
                            {accessCodesEditStore.datepickerStore.selectedDate.value}
                        </div>}
                </div>
                <div className={block('ContentWrapper')}>
                    <div className={block('importantSection')}>
                        <span className={block('subImportantSection')}>IMPORTANT</span>
                        {importantSection}
                    </div>
                    <ConsoleCheckbox
                        flagStore={accessCodesEditStore.confirmAction}
                        className={block('ActivationsCb')}
                    >{`${CB_LABEL_PREFIX} ${this.props.checkboxLabel}`}</ConsoleCheckbox>
                </div>
            </ConsoleModal>
        </Fragment>;
    }
}

export default inject('browserPolicies', 'snack')(observer(AccessCodeActionModal));
